import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { AudienceComponent } from '../components/audience/audience';

@Injectable({
  providedIn: 'root'
})
export class AudienceCreateExitGuard implements CanDeactivate<AudienceComponent> {
  canDeactivate(component: AudienceComponent): Promise<boolean> | boolean {
    return component.canDeactivateAudiencePage();
  }
}
